import { createSlice, PayloadAction } from "redux-starter-kit";
import { AlertProps } from "@amzn/awsui-components-react-v3";
import { BannerComponentId } from "./bannerComponentId";

export interface DisplayBanner {
  type: AlertProps["type"];
  header?: string;
  content?: string;
  dissmissible: boolean;
  buttonText?: string;
  onButtonClick?: PayloadAction;
  componentId?: BannerComponentId;
}

export interface BannerState {
  displayBanner: DisplayBanner | undefined;
}

const initialState: BannerState = {
  displayBanner: undefined,
};

export default createSlice({
  initialState,
  slice: "banner",
  reducers: {
    setBanner: (
      state: BannerState,
      action: PayloadAction<DisplayBanner | undefined, string>
    ) => {
      state.displayBanner = action.payload;
    },
  },
});
